'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFirstStage = exports.isTaskComplete = exports.getCurrentStage = exports.isStageComplete = exports.indexEvents = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _helper = require('./helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var indexEvents = function indexEvents() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var result = events.reduce(function (res, event) {
    if (!res[event.itemId]) {
      res[event.itemId] = [];
    }

    res[event.itemId].push(event);
  }, {});

  return result;
};

var isFirstStage = function isFirstStage(job, stage) {
  var result = stage && job && job.stages && job.stages.length > 0 && job.stages[0].id === stage.id;
  console.log('isFirst', result);
  return result;
};

var getCurrentStage = function getCurrentStage(task, stages) {
  if (stages) {
    return stages.find(function (stage) {
      if (!task.stages) {
        return true;
      }

      return !(stage.id in (task.stages || {})) || !task.stages[stage.id].completed && // complete
      !task.stages[stage.id].skipped;
    });

    // console.log('currentStage', task.id, result, stages, task.stages);

    // if (!result && stages.length > 0) {
    //   return null; //stages[0];
    // }
    //
    // return result;
  }

  return null;
};

var isStageComplete = function isStageComplete(task, stageId) {
  var items = (0, _helper.toArray)(task.items) || [];
  // let stage = (task.stages||{})[stageId] || {};
  // let stageEvents = indexEvents(stage.events || []);

  var missing = items.filter(function (item) {
    // let events = stageEvents[item.id];
    // if (events && events.length > 0) { // TODO check type of events
    //   return false;
    // }

    return !item.stages || !(stageId in item.stages) || !item.stages[stageId].acknowledged;
  });

  return {
    complete: missing.length === 0,
    missing: missing
  };
};

var isTaskComplete = function isTaskComplete(task) {
  var stages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var incompleteStages = stages.find(function (stage) {
    if (stage.id in (task.stages || {})) {
      return !(task.stages[stage.id].completed || task.stages[stage.id].skipped);
    } else {
      return true;
    }
  });

  console.log('isTaskComplete', incompleteStages);
  return !incompleteStages;
  // const stages = _.values(task.stages || {});
  // const incomplete = stages.filter(stage => stage !== 'C');
  // console.log('incomplete', incomplete);
  // return incomplete.length === 0;
};

exports.indexEvents = indexEvents;
exports.isStageComplete = isStageComplete;
exports.getCurrentStage = getCurrentStage;
exports.isTaskComplete = isTaskComplete;
exports.isFirstStage = isFirstStage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sakari-io/staza-common/dist/stages.js
// module id = 1149
// module chunks = 0